import * as Sentry from '@sentry/browser';

export const logError = (error) => {
  if (process.env.REACT_APP_CLIENT_ID !== 'onboarding.prod') {
    console.error(error);
  } else {
    Sentry.captureException(error);
  }
};
